import { render, staticRenderFns } from "./InputSigarus.vue?vue&type=template&id=f2c40a5c"
import script from "./InputSigarus.vue?vue&type=script&lang=js"
export * from "./InputSigarus.vue?vue&type=script&lang=js"
import style0 from "./InputSigarus.vue?vue&type=style&index=0&id=f2c40a5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports